import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WbIncandescentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wb_incandescent"}/>
}
